import { render, staticRenderFns } from "./email-conversation.vue?vue&type=template&id=5cd19e30&scoped=true"
import script from "./email-conversation.vue?vue&type=script&lang=js"
export * from "./email-conversation.vue?vue&type=script&lang=js"
import style0 from "./email-conversation.vue?vue&type=style&index=0&id=5cd19e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd19e30",
  null
  
)

export default component.exports